import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, ButtonLoader, MessageService } from '../../../../core';
import { Cliente } from '../../../pessoa/cliente/cliente';
import { ClienteCrudHttpService } from '../../../pessoa/cliente/services';
import { TypeaheadClienteComponent } from '../../../pessoa/cliente/typeahead';
import { ClienteCarteiraPreBaixar } from '../cliente-carteira-prebaixar';
import { ClienteCarteiraPreBaixado } from '../cliente-carteira-prebaixado';
import { ClienteCarteiraPreBaixarHttpService } from '../services';
import { RepresentanteCrudHttpService } from '../../../pessoa/representante/services';

@Component({
    selector: 'sgt-cliente-carteira-prebaixar-modal',
    templateUrl: './cliente-carteira-prebaixar-modal.component.html',
    styleUrls: ['./cliente-carteira-prebaixar-modal.component.less']
})
export class ClienteCarteiraPreBaixarModalComponent implements OnInit {
    entityPreBaixa: ClienteCarteiraPreBaixar;

    editMode: boolean;
    canEditCliente: boolean;
    elModal: any;

    @Input() isRepresentante: boolean;
    @Input() titleInsert = 'Pré-baixar cliente';
    @Input() subTitleInsert = 'Selecione o cliente e informe o motivo da pré-baixa deste cliente';
    @Input() titleEdit = 'Editar pré-baixa do cliente';
    @Input() subTitleEdit = 'Informe o motivo da pré-baixa deste cliente';
    @Input() clienteInputLabel = 'Cliente';
    @Input() btnBaixarText = 'Pré-Baixar Cliente';
    @Output() afterCancel = new EventEmitter<any>();
    @Output() afterInsertPreBaixa = new EventEmitter<ClienteCarteiraPreBaixado>();
    @Output() afterEditPreBaixa = new EventEmitter<ClienteCarteiraPreBaixado>();

    @ViewChild('form') form: NgForm;
    @ViewChild('typeaeadCliente') typeaeadCliente: TypeaheadClienteComponent;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private representanteCrudHttpService: RepresentanteCrudHttpService,
                private clienteCarteiraPreBaixarHttpService: ClienteCarteiraPreBaixarHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                if (this.canEditCliente) {
                    this.typeaeadCliente?.setFocus();
                } else {
                    jQuery('#motivoPreBaixaCliente').trigger('focus');
                }

                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Inserie uma nova pré-baixa */
    insert(idCliente: number) {
        this.editMode = false;
        this.elModal.modal({keyboard: false, backdrop: 'static'});

        this.entityPreBaixa = new ClienteCarteiraPreBaixar();
        // Se informado o cliente para ser pré-baixado então carregamos o cliente e não permitimos editar
        if (idCliente) {
            this.canEditCliente = false;
            this.loadCliente(idCliente);
        } else { // Se não, permite editar o cliente para poder selecioná-lo
            this.canEditCliente = true;
        }
    }

    /** Edita a pré-baixa do cliente informado */
    edit(idCliente: number) {
        this.editMode = true;
        this.canEditCliente = false;
        this.elModal.modal({keyboard: false, backdrop: 'static'});

        // Carregando os dados do cliente pré-baixado
        this.clienteCarteiraPreBaixarHttpService.loadPreBaixa(idCliente)
            .subscribe(
                clientePreBaixado => {
                    this.entityPreBaixa = new ClienteCarteiraPreBaixar();
                    this.loadCliente(clientePreBaixado.idCliente);
                    this.entityPreBaixa.dataPreBaixa = clientePreBaixado.dataPreBaixa;
                    this.entityPreBaixa.preBaixaManual = clientePreBaixado.preBaixaManual;
                    this.entityPreBaixa.nomeUsuarioPreBaixa = clientePreBaixado.nomeUsuarioPreBaixa;
                    this.entityPreBaixa.motivoPreBaixa = clientePreBaixado.motivoPreBaixa;
                },
                ((error: ApiError) => {
                    this.messageService.error(error.message, 'Ocorreu um erro ao carregar o cliente pré-baixado', error);
                    this.close();
                })
            );
    }

    /** Reseta o form e fecha o modal */
    private close() {
        this.elModal.modal('hide');
        this.entityPreBaixa = null;
    }

    /** Cancela a baixa do cliente */
    cancel() {
        this.close();
        this.afterCancel.emit();
    }

    /** Ao selecionar o cliente */
    onSelectCliente(cliente: Cliente) {
        if (cliente) {
            this.entityPreBaixa.idCliente = cliente.id;
            this.findRepresentanteCliente(cliente.idRepresentante);
        } else {
            this.onClearCliente();
        }
    }

    /** Ao remover o cliente */
    onClearCliente() {
        this.entityPreBaixa.idCliente = null;
        this.entityPreBaixa.representante = null;
    }

    /** Carrega o cliente da pré-baixa */
    private loadCliente(idCliente: number) {
        this.clienteCrudHttpService.load(idCliente)
            .subscribe(
                cliente => {
                    this.entityPreBaixa.cliente = cliente;
                    this.onSelectCliente(this.entityPreBaixa.cliente);
                },
                (() => {
                    this.entityPreBaixa.idCliente = null;
                    this.entityPreBaixa.cliente = null;
                })
            );
    }

    /** Pesquisa o representante do cliente da pré-baixa */
    private findRepresentanteCliente(idRepresentante: number) {
        this.representanteCrudHttpService.find(idRepresentante)
            .subscribe(
                representante => this.entityPreBaixa.representante = representante,
                () => this.entityPreBaixa.representante = null
            );
    }

    /** Realiza a pré-baixa do cliente */
    preBaixar() {
        if (this.form.valid) {
            const btn = new ButtonLoader('#btnClientePreBaixarModal');
            btn.loading('Pré-baixando');

            this.clienteCarteiraPreBaixarHttpService.preBaixar(this.entityPreBaixa)
                .subscribe(
                    clientePreBaixado => {
                        btn.reset();
                        this.messageService.success('', 'Cliente pré-baixado com sucesso');

                        if (!this.editMode) {
                            this.afterInsertPreBaixa.emit(clientePreBaixado);
                        } else {
                            this.afterEditPreBaixa.emit(clientePreBaixado);
                        }

                        this.close();
                    },
                    (error: ApiError) => {
                        btn.reset();
                        this.messageService.error(error.message, 'Erro ao pré-baixar o cliente', error);
                    }
                )
        } else {
            this.messageService.info('Para pré-baixar é necessário informar corretamente todos os campos destacados em vermelho', 'Informação');
        }
    }
}
